/**
 * useSearchPalette — shared signal for opening/closing the CommandPalette.
 *
 * Lives as a module-level singleton so any component can open the palette
 * without prop drilling.
 */

import { createSignal } from "solid-js";

const [isOpen, setIsOpen] = createSignal(false);

interface SearchPaletteControls {
  isOpen: () => boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

export function useSearchPalette(): SearchPaletteControls {
  return {
    isOpen,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false),
    toggle: () => setIsOpen((v) => !v),
  };
}
